var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1036_1818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7509 12.6984H0.333984V10.0434C0.333984 6.04582 3.58474 2.78607 7.58474 2.78607H14.8717V5.20518H7.58474C4.92009 5.20518 2.7509 7.37634 2.7509 10.0434V12.6984Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2793 0.5L20.3337 3.99562L14.2793 7.49728V0.5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0839 18.2139H5.79688V15.7948H13.0839C15.7485 15.7948 17.9177 13.6237 17.9177 10.9566V8.30164H20.3346V10.9566C20.3346 14.9602 17.0839 18.2139 13.0839 18.2139Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38837 20.5L0.333984 17.0044L6.38837 13.5027V20.5Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1036_1818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333984 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRePlay);
export default __webpack_public_path__ + "static/media/rePlay.ed4893d4dd0e152b4bd4828fb6780ea6.svg";
export { ForwardRef as ReactComponent };